<div ngbDropdown>
  <div id="trade-tagfield-dropdown" class="form-control p-0">
    @for (
      item of SelectedTradesAndCategories['Trades'];
      track item;
      let index = $index
    ) {
      <span class="badge bg-primary mx-1" contenteditable="false" tabindex="-1">
        {{ item.name }}
        <i
          class="bi bi-x-lg cursor-select"
          (click)="deselectTrade(item, index)"
        ></i>
      </span>
    }
    <div
      #TradeCategoryDiv
      (input)="filterTradesAndCategories($event)"
      class="dropdown-toggle-override form-control border-hidden box-shadow-hidden"
      contenteditable="true"
      ngbDropdownToggle
    ></div>
  </div>
  <ul
    class="trade-dropdown-menu w-100 vh-25 overflow-y-auto list-unstyled mb-0"
    ngbDropdownMenu
    aria-labelledby="trade-tagfield-dropdown"
  >
    @for (item of FilteredTradeCategories; track item) {
      <li class="trade-category-group">
        <div
          class="trade-category-header cursor-select d-flex align-items-center justify-content-between px-3 py-2"
          (click)="toggleCategoryExpanded(item.id)"
        >
          <span class="trade-category-name bold">{{ item.categoryName }}</span>
          <i
            class="bi chevron-icon"
            [class.bi-chevron-down]="!isCategoryExpanded(item.id)"
            [class.bi-chevron-up]="isCategoryExpanded(item.id)"
          ></i>
        </div>
        <div
          class="trade-category-items"
          [ngbCollapse]="!isCategoryExpanded(item.id)"
        >
          <ul class="list-unstyled mb-0 py-1">
            @for (Trade of item.PrimaryTrades; track Trade) {
              <li
                class="trade-item-row cursor-select d-flex align-items-center pr-3 py-2"
                [style.paddingLeft.px]="36"
                (click)="toggleTrade(Trade, item); $event.stopPropagation()"
              >
                <span class="trade-item-name">{{ Trade.name }}</span>
              </li>
            }
          </ul>
        </div>
      </li>
    }
  </ul>
</div>
